import {
  makeStyles,
  MenuItem,
  Select as MuiSelect,
  Typography,
} from "@material-ui/core";
import React from "react";
import { rowFlexAlignCenter } from "../../styles/common";

const useStyles = makeStyles((theme) => ({
  select: {
    fontSize: "14px !important",
  },
}));

const Select = ({
  label = "",
  labelPlacement = "start",
  labelFontWeight = 600,
  helperText = "",
  ...props
}) => {
  const classes = useStyles();
  const error = props.error;
  delete props.error;

  return (
    <div className={labelPlacement === "start" ? rowFlexAlignCenter : ""}>
      {label && (
        <Typography
          style={{
            fontSize: 14,
            fontWeight: labelFontWeight,
            minWidth:
              labelPlacement === "start"
                ? props.labelWidth
                  ? props.labelWidth
                  : 110
                : 0,
            maxWidth: labelPlacement === "start" ? 110 : "auto",
            marginRight: labelPlacement === "start" ? 8 : 0,
            marginTop: labelPlacement === "start" ? -18 : 0,
            marginBottom: labelPlacement === "top" ? 12 : 0,
          }}
        >
          {label}
        </Typography>
      )}
      <div
        style={{
          width: props.width ? props.width : "100%",
          ...(!props.width && { flexGrow: 1 }),
        }}
      >
        <MuiSelect
          color="secondary"
          variant={props?.variant ?? "outlined"}
          error={!!error}
          fullWidth
          classes={{ select: classes.select }}
          MenuProps={props.MenuProps}
          PopperProps={props.PopperProps}
          {...props}
        >
          {props.placeholder && (
            <MenuItem
              key="none"
              value="none"
              style={{
                fontSize: 12,
                color: "#999999",
              }}
            >
              {props.placeholder}
            </MenuItem>
          )}
          {props.options.map((item) => (
            <MenuItem
              key={item.id}
              value={item.id}
              style={{ fontSize: 12, color: "#1a1a1a" }}
            >
              {item.title}
            </MenuItem>
          ))}
        </MuiSelect>
        {helperText && (
          <Typography style={{ color: "#666666", fontSize: 12, margin: 2 }}>
            {helperText}
          </Typography>
        )}
        <Typography
          style={{ color: error ? "#F44336" : "#FFFFFF", fontSize: 12 }}
        >
          {error ? error : "&nbsp;"}
        </Typography>
      </div>
    </div>
  );
};

export default Select;
